import { LgpHeroStickyQuery } from '../types';
import { ILgpHeroSticky } from '@sky-it-livedata/livedata-sports-design-system';
import { RaceSessionStatus, RaceSessionType } from '../../../types/lgp';

import { isValidLgpHeroSticky } from './typeguards';
import { CreateLgpHeroStickyWidgetInputSchema, LgpHeroStickyInfo, LgpHeroStickySession } from 'cdk/graphql';
import { ErrorName, WidgetError } from '../../../utils/errors';

export default (obj: LgpHeroStickyQuery): ILgpHeroSticky => {
  if (isValidLgpHeroSticky(obj)) {
    CreateLgpHeroStickyWidgetInputSchema().parse(obj.data.getLgpHeroStickyWidget, {reportInput: true});

    const { info, session } = obj?.data.getLgpHeroStickyWidget;
    const { flagImgUrl, customGpName, startDate, endDate } = info as LgpHeroStickyInfo;
    const { label, status } = session as LgpHeroStickySession;

    return {
      flagImgUrl: flagImgUrl as string,
      customGpName: customGpName as string,
      startDate: startDate as string,
      endDate: endDate as string,
      sessionStatus: status as RaceSessionStatus,
      sessionName: label as RaceSessionType,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LgpHeroStickyQuery object',
      data: obj
    });
  }
};
